import styled from 'styled-components/macro';

export const CarDetailContent = styled.div`
	width: 1240px;
	max-width: 100%;
	margin: 0 auto;
	padding: 20px;
`;
